import BaseCollection from "lib/collection";
import Model from "models/view";
import pull from "lodash/pull";

export default BaseCollection.extend({
    model: Model,
    indexes: ["key"],
    callbacks: {},
    fetching: [],
    getOrFetchBySchema: function (viewName, schemaId) {
        return new Promise((resolve, reject) => {
            const key = viewName + "-" + schemaId;
            const model = this.get(key, "key");
            if (model) {
                resolve(model);
            } else {
                if (this.fetching.indexOf(key) !== -1) {
                    this.callbacks[key] = this.callbacks[key] || [];
                    this.callbacks[key].push([resolve, reject]);
                } else {
                    this.fetching.push(key);
                    this.fetchBySchema(viewName, schemaId, resolve, reject);
                }
            }
        });
    },
    // fetchById: fetches a model and adds it to
    // collection when fetched.
    fetchBySchema: function (viewName, schemaId, resolve, reject) {
        const key = viewName + "-" + schemaId;
        let model = new this.model(
            {
                schema_id: schemaId,
                view_name: viewName,
            },
            { collection: this }
        );

        const options = {};
        options.success = () => {
            model = this.add(model);
            resolve(model);
            if (this.callbacks[key]) {
                while (this.callbacks[key].length) {
                    const res = this.callbacks[key].pop()[0];
                    res(model);
                }
            }
            pull(this.fetching, key);
        };

        options.error = (collection, resp) => {
            delete model.collection;

            const err = new Error(resp.rawRequest.statusText);
            err.status = resp.rawRequest.status;

            reject(err);

            if (this.callbacks[key]) {
                while (this.callbacks[key].length) {
                    const rej = this.callbacks[key].pop()[1];
                    rej(err);
                }
            }
            pull(this.fetching, key);
        };

        return model.fetch(options);
    },
});
